import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const SettingsIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        className="tenera-icon"
        viewBox="0 0 26 26"
        fill="none"
        {...props}
    >
        <path
            d="M18.8613 12.8508C18.8613 16.088 16.2366 18.7111 12.9993 18.7111C9.76188 18.7111 7.13867 16.088 7.13867 12.8508C7.13867 9.61365 9.76333 6.9906 12.9993 6.9906C16.2352 6.9906 18.8613 9.61365 18.8613 12.8508Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.8508 14.6063V11.0736L21.4816 10.5421V10.5493C21.3672 10.1278 21.2223 9.71937 21.0485 9.32541C20.9225 9.03428 20.7791 8.75184 20.6212 8.47809L20.6299 8.48678L21.0485 7.90308L22.6201 5.7131L20.1229 3.2146L19.067 3.98226L17.365 5.22064L17.3737 5.22933C16.7291 4.85999 16.0353 4.56886 15.3023 4.37043H15.3096L14.7548 1H11.222L10.6904 4.37043H10.6976C9.96467 4.56886 9.27084 4.85999 8.62772 5.22933L8.63496 5.22064L5.87704 3.2146L3.37984 5.7131L5.37006 8.48678L5.37731 8.47809C5.00794 9.12118 4.7168 9.81641 4.51835 10.5479V10.5421L1.14917 11.0736V14.6063L4.51835 15.1596V15.1538C4.7168 15.8852 5.00794 16.5804 5.37731 17.2235L5.37006 17.2148L3.36391 19.9726L5.8611 22.4711L8.63496 20.481L8.62772 20.4723C9.27084 20.8416 9.96467 21.1328 10.6976 21.3312H10.6904L11.222 24.7016H14.7548L15.3096 21.3312H15.3023C16.0353 21.1328 16.7291 20.8416 17.3737 20.4723L17.365 20.481L20.1389 22.4711L22.636 19.9726L21.0485 17.7899L20.6299 17.2148L20.6212 17.2235C20.7791 16.9498 20.9225 16.6674 21.0485 16.3762C21.2223 15.9823 21.3672 15.5738 21.4816 15.1523V15.1596L24.8508 14.6063ZM12.9993 18.711C9.76333 18.711 7.13867 16.088 7.13867 12.8508C7.13867 9.61364 9.76333 6.99059 12.9993 6.99059C16.2352 6.99059 18.8613 9.61364 18.8613 12.8508C18.8613 16.088 16.2366 18.711 12.9993 18.711Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default withCustomIcon(SettingsIcon); 